import classnames from 'classnames';
import React from 'react';

import {
  PersistedQueryListConfigStep,
  PersistedQueryListConfigWorkflow,
  getPQConfigWorkflowSteps,
} from './steps';

export const PersistedQueryListConfigHeader = ({
  currentStep,
  workflow,
}: {
  currentStep: PersistedQueryListConfigStep;
  workflow: PersistedQueryListConfigWorkflow;
}) => {
  const workflowSteps = getPQConfigWorkflowSteps(workflow);
  const currentStepIdx = workflowSteps.indexOf(currentStep);
  /* TODO(tim): this could be refactored into a shared component with Contract Config and UpgradeModal */
  return (
    <div className="mb-2 flex items-center rounded border border-silver bg-silver-lighter p-4">
      {workflowSteps.map((step, idx) => (
        <React.Fragment key={step}>
          {/* connector */}
          {idx !== 0 && (
            <div
              className={classnames('mx-3 h-0 flex-1 border', {
                'border-blue': idx <= currentStepIdx,
                'border-dashed border-grey-lighter': idx > currentStepIdx,
              })}
            />
          )}
          <div className="flex text-sm">
            {/* step number */}
            <div
              className={classnames(
                'flex size-5 items-center justify-center rounded-full border',
                {
                  'border-blue bg-blue text-inverted': idx < currentStepIdx,
                  'border-blue text-link': idx === currentStepIdx,
                  'border-grey-lighter text-secondary': idx > currentStepIdx,
                },
              )}
            >
              {idx + 1}
            </div>
            {/* step title */}
            <div
              className={classnames('ml-2', {
                'text-black': idx < currentStepIdx,
                'text-link': idx === currentStepIdx,
                'text-secondary': idx > currentStepIdx,
              })}
            >
              {step}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
